var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loadingScreenCustomizations)?_c('SplashScreen',{attrs:{"status":'active',"failure":false,"loading-screen-customizations":_vm.loadingScreenCustomizations}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }